import { For, createMemo } from 'solid-js';
import {
  activityFill,
  dayKey,
  formatDayScore,
  startOfLocalDay,
  yearWeeks,
  type ActivityMap,
} from '@domain/openings/activity';
import './ActivityChart.css';

const DAY_LABELS = ['', 'Mon', '', 'Wed', '', 'Fri', ''];
const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export function ActivityChart(props: { activity: ActivityMap; now?: Date }) {
  const weeks = createMemo(() => yearWeeks(props.now ?? new Date()));
  const todayKey = createMemo(() => dayKey(startOfLocalDay(props.now ?? new Date())));

  const monthLabels = createMemo(() => {
    const ws = weeks();
    return ws.map((week, i) => {
      const prev = i > 0 ? ws[i - 1]![0] : undefined;
      const cur = week[0]!;
      if (i === 0 || prev!.getMonth() !== cur.getMonth()) {
        return MONTHS[cur.getMonth()]!;
      }
      return '';
    });
  });

  return (
    <div class="activity" aria-label="Quiz activity">
      <div class="activity__months" aria-hidden="true">
        <span class="activity__day-gutter" />
        <For each={monthLabels()}>
          {(label) => <span class="activity__month">{label}</span>}
        </For>
      </div>
      <div class="activity__body">
        <div class="activity__dow" aria-hidden="true">
          <For each={DAY_LABELS}>{(lab) => <span>{lab}</span>}</For>
        </div>
        <div class="activity__grid">
          <For each={weeks()}>
            {(week) => (
              <div class="activity__week">
                <For each={week}>
                  {(day) => {
                    const key = dayKey(day);
                    const rec = () => props.activity[key];
                    const future = day.getTime() > (props.now ?? new Date()).getTime();
                    const score = () => formatDayScore(rec());
                    return (
                      <span
                        class="activity__cell"
                        classList={{
                          'is-today': key === todayKey(),
                          'is-future': future,
                        }}
                        style={{ background: future ? undefined : activityFill(rec()) }}
                        title={score()}
                      />
                    );
                  }}
                </For>
              </div>
            )}
          </For>
        </div>
      </div>
    </div>
  );
}
